export default __webpack_public_path__ + "static/media/cluster.fae5f0f2.svg";